export default "__VITE_ASSET__3bcbf6d9__"